var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Combobox',{attrs:{"title":_vm.$t('referenceBooks.devices.Device'),"keyName":'deviceId',"item-text":'deviceName',"item-value":'deviceId',"disabled":_vm.mode === 1,"needCheck":_vm.needCheck,"items":_vm.items},on:{"change":_vm.onChange},model:{value:(_vm.selectedData),callback:function ($$v) {_vm.selectedData=$$v},expression:"selectedData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }